import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/admin/ManageUser.js";
import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Grid, FormControl, FormControlLabel, InputLabel, Input, Button, FormHelperText, Select, MenuItem, Checkbox, Typography, Box } from "@material-ui/core";
import { BASE_URIS, ROLES, SERIES_MASTER_ROLLUP_VODPROVIDERSOURCE as PROVIDER_SOURCE, SESSION_STORAGE_ITEM_NAMES } from "../domain/constants";
import { Dialog } from "../common";
import Util, { getSelectedPartner } from "../../util/Util";
import { digestMessage, hexString, generateRandomPassword } from '../../util/PasswordUtil';
import LinearProgress from "@material-ui/core/LinearProgress";
import { isABlankString, isNotABlankString } from "../../util/StringUtil";
import { isNotAnEmptyArray } from "../../util/ArrayUtil";
const styles = () => ({
  root: {
    width: '100%',
    marginTop: 0,
    overflowX: 'auto'
  },
  centerText: {
    textAlign: 'center'
  },
  formControl: {
    width: '85%'
  }
});
class ManageUser extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      this.setState({
        [name]: event.target.value
      });
    });
    _defineProperty(this, "handleCheckChange", name => event => {
      this.setState({
        [name]: event.target.checked
      });
    });
    this.state = {
      username: null,
      //string
      password: null,
      //string
      email: null,
      //string
      satClientId: null,
      //string
      satClientSecret: null,
      //string
      role: ROLES.provider,
      //string
      provider: null,
      //string
      legacyProvider: null,
      active: true,
      //boolean
      auditMethod: auditPublishMethods.MANUAL,
      //string
      publishMethod: auditPublishMethods.MANUAL,
      //string
      visiblePartnerIds: [visiblePartners.COMCAST.ID],
      visibleEntityProviders: [VISIBLE_ENTITY_PROVIDERS.ADI],
      visibleVodProviders: '',
      visibleCompanyIds: '',
      visibleImageTypeIds: '',
      visibleUploadProviders: '',
      visibleLegacyUploadProviders: '',
      // MERPLAT-3255
      relaxedProgramTypes: '',
      visibleVodProvidersNullable: false,
      relaxedProgramTypesNullable: false,
      visibleCompanyIdsNullable: false,
      refreshProgramCache: false,
      refreshProgramCacheAsynchronously: false,
      seriesMasterRollupEnabled: false,
      // MERPLAT-3603: TPIS++
      imageDistributorCompanyId: null,
      seriesMasterRollupVODProviderSource: [],
      seriesMasterRollupExclusivesOnly: false,
      shortformPrefixes: '',
      longformPrefixes: '',
      liveEventPrefixes: '',
      defaultAspectRatio: null,
      defaultSpecialSelectionRule: null,
      specialSelectionRules: '',
      // MERPLAT-3679
      partnerOwnerId: '',
      visibleLocationIds: [],
      // MERPLAT-4080
      extendedSearchEnabled: false,
      loading: false,
      success: false,
      mode: props.mode != null ? props.mode : MODE.CREATE,
      selectedUser: props.selectedUser,
      parent: props.parent
    };
    this.setUpSelectedUser();
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
  }

  // Called when we're in MODE.UPDATE
  setUpSelectedUser() {
    const _this$state = this.state,
      mode = _this$state.mode,
      selectedUser = _this$state.selectedUser;
    if (mode === MODE.UPDATE && selectedUser != null) {
      this.state.username = selectedUser.username;
      this.state.email = selectedUser.email;
      this.state.satClientId = selectedUser.clientId;
      this.state.role = determineValue(selectedUser.role, ROLES);
      this.state.provider = selectedUser.provider;
      this.state.legacyProvider = selectedUser.legacyProvider;
      this.state.active = selectedUser.active != null ? selectedUser.active : false;
      this.state.auditMethod = determineValue(selectedUser.auditMethod, auditPublishMethods);
      this.state.publishMethod = determineValue(selectedUser.publishMethod, auditPublishMethods);
      this.state.visiblePartnerIds = selectedUser.visiblePartnerIds;
      this.state.visibleEntityProviders = selectedUser.visibleEntityProviders;
      this.state.visibleVodProviders = selectedUser.visibleVodProviders;
      this.state.visibleCompanyIds = selectedUser.visibleCompanyIds;
      this.state.visibleImageTypeIds = selectedUser.visibleImageTypeIds;
      this.state.visibleUploadProviders = selectedUser.visibleUploadProviders;
      this.state.visibleLegacyUploadProviders = selectedUser.visibleLegacyUploadProviders;
      this.state.relaxedProgramTypes = selectedUser.relaxedProgramTypes;
      this.state.visibleVodProvidersNullable = false;
      this.state.relaxedProgramTypesNullable = false;
      this.state.visibleCompanyIdsNullable = false;
      this.state.refreshProgramCache = selectedUser.refreshProgramCache;
      this.state.refreshProgramCacheAsynchronously = selectedUser.refreshProgramCacheAsynchronously;
      this.state.seriesMasterRollupEnabled = selectedUser.seriesMasterRollupEnabled;
      this.state.imageDistributorCompanyId = selectedUser.imageDistributorCompanyId;
      this.state.seriesMasterRollupVODProviderSource = selectedUser.seriesMasterRollupVODProviderSource;
      this.state.seriesMasterRollupExclusivesOnly = selectedUser.seriesMasterRollupExclusivesOnly;
      this.state.shortformPrefixes = selectedUser.shortformPrefixes;
      this.state.longformPrefixes = selectedUser.longformPrefixes;
      this.state.liveEventPrefixes = selectedUser.liveEventPrefixes;
      this.state.defaultAspectRatio = selectedUser.defaultAspectRatio;
      this.state.defaultSpecialSelectionRule = selectedUser.defaultSpecialSelectionRule;
      this.state.specialSelectionRules = selectedUser.specialSelectionRules;
      this.state.partnerOwnerId = selectedUser.partnerOwnerId;
      this.state.visibleLocationIds = selectedUser.visibleLocationIds;
      this.state.extendedSearchEnabled = selectedUser.extendedSearchEnabled != null ? selectedUser.extendedSearchEnabled : false;
    }
  }

  // Only called in MODE.CREATE
  reset() {
    this.setState({
      username: null,
      password: null,
      email: null,
      satClientId: null,
      satClientSecret: null,
      role: ROLES.provider,
      provider: null,
      legacyProvider: null,
      active: true,
      auditMethod: auditPublishMethods.MANUAL,
      publishMethod: auditPublishMethods.MANUAL,
      visiblePartnerIds: [visiblePartners.COMCAST.ID],
      visibleEntityProviders: [VISIBLE_ENTITY_PROVIDERS.ADI],
      visibleVodProviders: '',
      visibleCompanyIds: '',
      visibleImageTypeIds: '',
      visibleUploadProviders: '',
      visibleLegacyUploadProviders: '',
      loading: false,
      relaxedProgramTypes: '',
      visibleVodProvidersNullable: false,
      relaxedProgramTypesNullable: false,
      visibleCompanyIdsNullable: false,
      refreshProgramCache: false,
      refreshProgramCacheAsynchronously: false,
      seriesMasterRollupEnabled: false,
      imageDistributorCompanyId: null,
      seriesMasterRollupVODProviderSource: [],
      seriesMasterRollupExclusivesOnly: false,
      shortformPrefixes: '',
      longformPrefixes: '',
      liveEventPrefixes: '',
      defaultAspectRatio: null,
      defaultSpecialSelectionRule: null,
      specialSelectionRules: '',
      partnerOwnerId: '',
      visibleLocationIds: [],
      extendedSearchEnabled: false
    });
  }

  /**
   * Use appendIfNotNull for values that can be nulled to avoid sending a blank string
   * Use data.append for values that are not nullable
   */
  async submitUserCreationRequest() {
    // ignore satClientId and satClientSecret since they can be left blank at user creation
    const validation = this.validateUserManagementRequest(true, false);
    if (validation.result === false) {
      let message;
      if (validation.message != null) {
        message = validation.message;
      } else {
        message = "".concat(validation.field, " is a required field");
      }
      Util.createDialog('Failure', message, this.dialogRef);
    } else {
      const _this$state2 = this.state,
        username = _this$state2.username,
        email = _this$state2.email,
        satClientId = _this$state2.satClientId,
        satClientSecret = _this$state2.satClientSecret,
        role = _this$state2.role,
        provider = _this$state2.provider,
        legacyProvider = _this$state2.legacyProvider,
        visiblePartnerIds = _this$state2.visiblePartnerIds,
        visibleEntityProviders = _this$state2.visibleEntityProviders,
        active = _this$state2.active,
        auditMethod = _this$state2.auditMethod,
        publishMethod = _this$state2.publishMethod,
        visibleVodProviders = _this$state2.visibleVodProviders,
        visibleCompanyIds = _this$state2.visibleCompanyIds,
        visibleImageTypeIds = _this$state2.visibleImageTypeIds,
        visibleUploadProviders = _this$state2.visibleUploadProviders,
        visibleLegacyUploadProviders = _this$state2.visibleLegacyUploadProviders,
        relaxedProgramTypes = _this$state2.relaxedProgramTypes,
        visibleVodProvidersNullable = _this$state2.visibleVodProvidersNullable,
        refreshProgramCache = _this$state2.refreshProgramCache,
        refreshProgramCacheAsynchronously = _this$state2.refreshProgramCacheAsynchronously,
        relaxedProgramTypesNullable = _this$state2.relaxedProgramTypesNullable,
        seriesMasterRollupEnabled = _this$state2.seriesMasterRollupEnabled,
        visibleCompanyIdsNullable = _this$state2.visibleCompanyIdsNullable,
        imageDistributorCompanyId = _this$state2.imageDistributorCompanyId,
        seriesMasterRollupVODProviderSource = _this$state2.seriesMasterRollupVODProviderSource,
        seriesMasterRollupExclusivesOnly = _this$state2.seriesMasterRollupExclusivesOnly,
        shortformPrefixes = _this$state2.shortformPrefixes,
        longformPrefixes = _this$state2.longformPrefixes,
        liveEventPrefixes = _this$state2.liveEventPrefixes,
        defaultAspectRatio = _this$state2.defaultAspectRatio,
        defaultSpecialSelectionRule = _this$state2.defaultSpecialSelectionRule,
        specialSelectionRules = _this$state2.specialSelectionRules,
        partnerOwnerId = _this$state2.partnerOwnerId,
        visibleLocationIds = _this$state2.visibleLocationIds,
        extendedSearchEnabled = _this$state2.extendedSearchEnabled;
      const password = await generateRandomPassword();
      const passwordArray = await digestMessage(password);
      const hashedPassword = hexString(passwordArray).toUpperCase();
      const data = new FormData();
      data.append('username', username);
      data.append('password', hashedPassword);
      data.append('email', email);
      appendIfNotNull(data, satClientId, 'satClientId');
      appendIfNotNull(data, satClientSecret, 'satClientSecret');
      data.append('role', role.toUpperCase());
      data.append('provider', provider);
      appendIfNotNull(data, legacyProvider, 'legacyProvider');
      data.append('active', active);
      data.append('auditMethod', auditMethod);
      data.append('publishMethod', publishMethod);
      data.append('visiblePartnerIds', visiblePartnerIds);
      data.append('visibleEntityProviders', visibleEntityProviders);
      if (visibleVodProvidersNullable === false) {
        data.append('visibleVodProviders', arrayFromCommaSeparatedListString(visibleVodProviders));
      } else {
        data.append('visibleVodProvidersNullable', visibleVodProvidersNullable);
      }
      if (visibleCompanyIdsNullable === false) {
        data.append('visibleCompanyIds', arrayFromCommaSeparatedListString(visibleCompanyIds));
      } else {
        data.append('visibleCompanyIdsNullable', visibleCompanyIdsNullable);
      }
      data.append('visibleImageTypeIds', arrayFromCommaSeparatedListString(visibleImageTypeIds));
      data.append('visibleUploadProviders', arrayFromCommaSeparatedListString(visibleUploadProviders));
      data.append('visibleLegacyUploadProviders', arrayFromCommaSeparatedListString(visibleLegacyUploadProviders));
      if (relaxedProgramTypesNullable === false) {
        data.append('relaxedProgramTypes', arrayFromCommaSeparatedListString(relaxedProgramTypes));
      } else {
        data.append('relaxedProgramTypesNullable', relaxedProgramTypesNullable);
      }
      data.append('refreshProgramCache', refreshProgramCache);
      data.append('refreshProgramCacheAsynchronously', refreshProgramCacheAsynchronously);
      data.append('seriesMasterRollupEnabled', seriesMasterRollupEnabled);
      appendIfNotNull(data, imageDistributorCompanyId, 'imageDistributorCompanyId');
      data.append('seriesMasterRollupVODProviderSource', seriesMasterRollupVODProviderSource);
      data.append('seriesMasterRollupExclusivesOnly', seriesMasterRollupExclusivesOnly);
      data.append('shortformPrefixes', arrayFromCommaSeparatedListString(shortformPrefixes));
      data.append('longformPrefixes', arrayFromCommaSeparatedListString(longformPrefixes));
      data.append('liveEventPrefixes', arrayFromCommaSeparatedListString(liveEventPrefixes));
      data.append('defaultAspectRatio', defaultAspectRatio);
      data.append('defaultSpecialSelectionRule', defaultSpecialSelectionRule);
      data.append('specialSelectionRules', arrayFromCommaSeparatedListString(specialSelectionRules));
      data.append('partnerOwnerId', partnerOwnerId);
      data.append('visibleLocationIds', arrayFromCommaSeparatedListString(visibleLocationIds));
      data.append('extendedSearchEnabled', extendedSearchEnabled);
      const uri = BASE_URIS.prefix + BASE_URIS.createUser;
      this.state.loading = true;
      this.state.success = false;
      this.forceUpdate();
      fetch(uri, {
        method: 'POST',
        credentials: 'include',
        body: new URLSearchParams(data),
        headers: {
          'x-meta-tpic-partner': getSelectedPartner()
        }
      }).then(resp => {
        if (resp != null && resp.status === 200) {
          this.state.success = true;
        }
        return resp.json();
      }).then(resp => {
        if (this.state.success === true) {
          Util.createDialog('Success', "User '".concat(username, "' created successfully. Generated password: ").concat(password, " (this has also been emailed to the user)"), this.dialogRef);
          this.sendMail(password);
          this.reset();
        } else if (resp != null && resp.status != null) {
          switch (resp.status) {
            case 400:
              Util.createDialog('Failure', 'Bad Request. Message from server: ' + resp.message, this.dialogRef);
              break;
            case 401:
              Util.createDialog('Failure', 'You are not permitted to create users', this.dialogRef);
              break;
            case 403:
              Util.createDialog('Failure', 'You are not permitted to create this user. Message from server: ' + resp.message, this.dialogRef);
              break;
            default:
              Util.createDialog('Failure', 'Message from server: ' + resp.message, this.dialogRef);
          }
          this.state.loading = false;
          this.forceUpdate();
        } else {
          Util.createDialog('Error', 'Did not receive a proper response from TPIS', this.dialogRef);
          this.state.loading = false;
          this.forceUpdate();
        }
      });
    }
  }
  /**
   * Use appendIfNotNull for values that cannot be nulled
   * Use data.append for values that are nullable
   */
  submitUserUpdateRequest() {
    const validation = this.validateUserManagementRequest(true, true);
    if (validation.result === false) {
      let message;
      if (validation.message != null) {
        message = validation.message;
      } else {
        message = "".concat(validation.field, " cannot be updated to empty") + (validation.nullableFlag === true ? ' without setting the nullable flag' : '');
      }
      Util.createDialog('Failure', message, this.dialogRef);
    } else {
      const _this$state3 = this.state,
        username = _this$state3.username,
        email = _this$state3.email,
        satClientId = _this$state3.satClientId,
        satClientSecret = _this$state3.satClientSecret,
        role = _this$state3.role,
        provider = _this$state3.provider,
        legacyProvider = _this$state3.legacyProvider,
        active = _this$state3.active,
        auditMethod = _this$state3.auditMethod,
        publishMethod = _this$state3.publishMethod,
        visiblePartnerIds = _this$state3.visiblePartnerIds,
        visibleEntityProviders = _this$state3.visibleEntityProviders,
        visibleVodProviders = _this$state3.visibleVodProviders,
        visibleCompanyIds = _this$state3.visibleCompanyIds,
        visibleImageTypeIds = _this$state3.visibleImageTypeIds,
        visibleUploadProviders = _this$state3.visibleUploadProviders,
        visibleLegacyUploadProviders = _this$state3.visibleLegacyUploadProviders,
        relaxedProgramTypes = _this$state3.relaxedProgramTypes,
        refreshProgramCache = _this$state3.refreshProgramCache,
        refreshProgramCacheAsynchronously = _this$state3.refreshProgramCacheAsynchronously,
        relaxedProgramTypesNullable = _this$state3.relaxedProgramTypesNullable,
        seriesMasterRollupEnabled = _this$state3.seriesMasterRollupEnabled,
        visibleCompanyIdsNullable = _this$state3.visibleCompanyIdsNullable,
        visibleVodProvidersNullable = _this$state3.visibleVodProvidersNullable,
        imageDistributorCompanyId = _this$state3.imageDistributorCompanyId,
        seriesMasterRollupVODProviderSource = _this$state3.seriesMasterRollupVODProviderSource,
        seriesMasterRollupExclusivesOnly = _this$state3.seriesMasterRollupExclusivesOnly,
        shortformPrefixes = _this$state3.shortformPrefixes,
        longformPrefixes = _this$state3.longformPrefixes,
        liveEventPrefixes = _this$state3.liveEventPrefixes,
        defaultAspectRatio = _this$state3.defaultAspectRatio,
        defaultSpecialSelectionRule = _this$state3.defaultSpecialSelectionRule,
        specialSelectionRules = _this$state3.specialSelectionRules,
        partnerOwnerId = _this$state3.partnerOwnerId,
        visibleLocationIds = _this$state3.visibleLocationIds,
        extendedSearchEnabled = _this$state3.extendedSearchEnabled;
      const uri = BASE_URIS.prefix + BASE_URIS.updateUser;
      const data = new FormData();
      // password and satClientId are not currently updatable here
      appendIfNotNull(data, username, 'username');
      appendIfNotNull(data, email, 'email');
      appendIfNotNull(data, satClientId, 'satClientId');
      appendIfNotNull(data, satClientSecret, 'satClientSecret');
      appendIfNotNull(data, role, 'role');
      appendIfNotNull(data, provider, 'provider');
      appendIfNotNull(data, legacyProvider, 'legacyProvider');
      appendIfNotNull(data, active, 'active');
      appendIfNotNull(data, auditMethod, 'auditMethod');
      appendIfNotNull(data, publishMethod, 'publishMethod');
      appendIfNotNull(data, visiblePartnerIds, 'visiblePartnerIds');
      if (visibleVodProvidersNullable === false) {
        appendIfNotNull(data, visibleVodProviders, 'visibleVodProviders');
      } else {
        data.append('visibleVodProvidersNullable', visibleVodProvidersNullable);
      }

      // Can be updated to null as of MERPLAT-3135
      if (visibleCompanyIdsNullable === false) {
        data.append('visibleCompanyIds', visibleCompanyIds);
      } else {
        data.append('visibleCompanyIdsNullable', visibleCompanyIdsNullable);
      }
      appendIfNotNull(data, visibleEntityProviders, 'visibleEntityProviders');
      appendIfNotNull(data, visibleImageTypeIds, 'visibleImageTypeIds');
      // Can be updated to null as of MERPLAT-3135
      data.append('visibleUploadProviders', visibleUploadProviders);
      // Can be updated to null as of MERPLAT-3135
      data.append('visibleLegacyUploadProviders', visibleLegacyUploadProviders);
      data.append('userId', this.state.selectedUser.id);
      if (relaxedProgramTypesNullable === false) {
        appendIfNotNull(data, arrayFromCommaSeparatedListString(relaxedProgramTypes), 'relaxedProgramTypes');
      } else {
        data.append('relaxedProgramTypesNullable', relaxedProgramTypesNullable);
      }
      appendIfNotNull(data, refreshProgramCache, 'refreshProgramCache');
      appendIfNotNull(data, refreshProgramCacheAsynchronously, 'refreshProgramCacheAsynchronously');
      appendIfNotNull(data, seriesMasterRollupEnabled, 'seriesMasterRollupEnabled');
      if (isABlankString(imageDistributorCompanyId)) {
        data.append('imageDistributorCompanyId', '');
      } else {
        data.append('imageDistributorCompanyId', imageDistributorCompanyId);
      }
      appendIfNotNull(data, seriesMasterRollupVODProviderSource, 'seriesMasterRollupVODProviderSource');
      appendIfNotNull(data, seriesMasterRollupExclusivesOnly, 'seriesMasterRollupExclusivesOnly');
      data.append('shortformPrefixes', arrayFromCommaSeparatedListString(shortformPrefixes));
      data.append('longformPrefixes', arrayFromCommaSeparatedListString(longformPrefixes));
      data.append('liveEventPrefixes', arrayFromCommaSeparatedListString(liveEventPrefixes));
      data.append('defaultAspectRatio', defaultAspectRatio);
      if (isABlankString(defaultSpecialSelectionRule)) {
        data.append('defaultSpecialSelectionRule', '');
      } else {
        data.append('defaultSpecialSelectionRule', defaultSpecialSelectionRule);
      }
      data.append('specialSelectionRules', arrayFromCommaSeparatedListString(specialSelectionRules));
      appendIfNotNull(data, partnerOwnerId, 'partnerOwnerId');
      data.append('visibleLocationIds', arrayFromCommaSeparatedListString(visibleLocationIds));
      appendIfNotNull(data, extendedSearchEnabled, 'extendedSearchEnabled');

      // print key/value pairs in data to console (for debug purposes)
      // for (let x of data.entries()) {
      //     console.dir('' + x[0] + ': ' + x[1]);
      // }

      fetch(uri, {
        method: 'POST',
        credentials: 'include',
        body: new URLSearchParams(data),
        headers: {
          'x-meta-tpic-partner': getSelectedPartner()
        }
      }).then(resp => {
        if (resp != null && resp.status === 200) {
          this.state.success = true;
        }
        return resp.json();
      }).then(resp => {
        if (this.state.success === true) {
          // Setting these fields on the parent will unmount this entire ManageUser component
          // and force it to reload the users table with the updated user fields
          if (this.state.parent != null) {
            // You're not supposed to do this but it works just fine
            this.state.parent.setState({
              selectedUser: null,
              userIsSelected: false,
              updated: true
            });
          }
        } else {
          Util.createDialog('Failure', 'Issue updating user. Message from server: ' + resp.message, this.dialogRef);
        }
      });
    }
  }
  sendMail(password) {
    const _this$state4 = this.state,
      email = _this$state4.email,
      username = _this$state4.username;
    const csrfToken = sessionStorage.getItem(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN);
    const messageBody = {
      recipient: email,
      body: "Username: ".concat(username, "\nPassword: ").concat(password, "\n\nDo not respond to this email. This mailbox is not monitored.")
    };
    fetch(BASE_URIS.mail, {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'x-meta-tpic-token': csrfToken
      },
      body: JSON.stringify(messageBody),
      credentials: "include"
    }).then(resp => {
      // noop
    });
  }
  render() {
    const classes = this.props.classes;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '80vh',
        minWidth: '80vw',
        marginTop: 0
      },
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 481,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 482,
        columnNumber: 17
      }
    }), this.state.loading === true && /*#__PURE__*/React.createElement(LinearProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 484,
        columnNumber: 17
      }
    }), this.state.loading === false && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      alignContent: 'center',
      alignItems: "center",
      justify: "space-evenly",
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 487,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: "center",
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 3,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 490,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 493,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 494,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "username",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 495,
        columnNumber: 33
      }
    }, "Username"), /*#__PURE__*/React.createElement(Input, {
      id: "username",
      value: this.state.username,
      fullWidth: true,
      onChange: this.handleChange('username'),
      "aria-describedby": "username-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 496,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 502,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 503,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "email",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 504,
        columnNumber: 33
      }
    }, "Email"), /*#__PURE__*/React.createElement(Input, {
      id: "email",
      value: this.state.email,
      fullWidth: true,
      onChange: this.handleChange('email'),
      "aria-describedby": "email-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 505,
        columnNumber: 33
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 512,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 515,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 516,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "satClientId",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 517,
        columnNumber: 33
      }
    }, "SAT Client ID"), /*#__PURE__*/React.createElement(Input, {
      id: "satClientId",
      value: this.state.satClientId,
      fullWidth: true,
      onChange: this.handleChange('satClientId'),
      "aria-describedby": "satClientId-field",
      placeholder: "Client ID and Client Secret can be left blank",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 518,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 525,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 526,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "satClientSecret",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 527,
        columnNumber: 33
      }
    }, "SAT Client Secret ", MODE.UPDATE === this.state.mode ? "(Leave blank to ignore this field while updating user)" : ''), /*#__PURE__*/React.createElement(Input, {
      id: "satClientSecret",
      value: this.state.satClientSecret,
      fullWidth: true,
      onChange: this.handleChange('satClientSecret'),
      "aria-describedby": "satClientSecret-field",
      placeholder: "Input plaintext satClientSecret. TPIS will handle the encryption",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 529,
        columnNumber: 33
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 538,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 541,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 542,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "role",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 543,
        columnNumber: 33
      }
    }, "Role"), /*#__PURE__*/React.createElement(Select, {
      value: this.state.role,
      onChange: this.handleChange('role'),
      "aria-describedby": "role-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 544,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: ROLES.admin,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 546,
        columnNumber: 37
      }
    }, "Admin"), /*#__PURE__*/React.createElement(MenuItem, {
      value: ROLES.provider,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 547,
        columnNumber: 37
      }
    }, "Provider"), /*#__PURE__*/React.createElement(MenuItem, {
      value: ROLES.auditor,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 548,
        columnNumber: 37
      }
    }, "Auditor"), /*#__PURE__*/React.createElement(MenuItem, {
      value: ROLES.publisher,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 549,
        columnNumber: 37
      }
    }, "Publisher"), /*#__PURE__*/React.createElement(MenuItem, {
      value: ROLES.manager,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 550,
        columnNumber: 37
      }
    }, "Manager")))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 556,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 557,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "provider",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 558,
        columnNumber: 33
      }
    }, "Provider"), /*#__PURE__*/React.createElement(Input, {
      id: "provider",
      value: this.state.provider,
      fullWidth: true,
      onChange: this.handleChange('provider'),
      "aria-describedby": "provider-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 559,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 565,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 566,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "legacyProvider",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 567,
        columnNumber: 33
      }
    }, "Legacy Provider"), /*#__PURE__*/React.createElement(Input, {
      id: "legacyProvider",
      value: this.state.legacyProvider,
      fullWidth: true,
      onChange: this.handleChange('legacyProvider'),
      "aria-describedby": "legacyProvider-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 568,
        columnNumber: 33
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 576,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 578,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 579,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      shrink: true,
      htmlFor: "visiblePartnerIds",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 580,
        columnNumber: 33
      }
    }, "Visible Partner Ids"), /*#__PURE__*/React.createElement(Select, {
      multiple: true,
      value: this.state.visiblePartnerIds,
      onChange: this.handleChange('visiblePartnerIds'),
      "aria-describedby": "visiblePartnerIds-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 581,
        columnNumber: 33
      }
    }, Object.keys(visiblePartners).map(partner => /*#__PURE__*/React.createElement(MenuItem, {
      value: visiblePartners[partner].ID,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 585,
        columnNumber: 41
      }
    }, visiblePartners[partner].NAME))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 592,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 593,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleEntityProviders",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 594,
        columnNumber: 33
      }
    }, "Visible Entity Providers"), /*#__PURE__*/React.createElement(Select, {
      multiple: true,
      value: this.state.visibleEntityProviders,
      onChange: this.handleChange('visibleEntityProviders'),
      "aria-describedby": "visibleEntityProviders-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 595,
        columnNumber: 33
      }
    }, Object.values(VISIBLE_ENTITY_PROVIDERS).map(entityProvider => /*#__PURE__*/React.createElement(MenuItem, {
      value: entityProvider,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 599,
        columnNumber: 41
      }
    }, entityProvider)))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 606,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 609,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.active,
        onChange: this.handleCheckChange('active'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 612,
          columnNumber: 56
        }
      }),
      label: "Active",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 610,
        columnNumber: 29
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 620,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 621,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "auditMethod",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 622,
        columnNumber: 33
      }
    }, "Audit Method"), /*#__PURE__*/React.createElement(Select, {
      value: this.state.auditMethod,
      onChange: this.handleChange('auditMethod'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 623,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: auditPublishMethods.MANUAL,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 624,
        columnNumber: 37
      }
    }, auditPublishMethods.MANUAL), /*#__PURE__*/React.createElement(MenuItem, {
      value: auditPublishMethods.AUTOMATIC,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 625,
        columnNumber: 37
      }
    }, auditPublishMethods.AUTOMATIC)))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 632,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 633,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "publishMethod",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 634,
        columnNumber: 33
      }
    }, "Publish Method"), /*#__PURE__*/React.createElement(Select, {
      value: this.state.publishMethod,
      onChange: this.handleChange('publishMethod'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 635,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: auditPublishMethods.MANUAL,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 636,
        columnNumber: 37
      }
    }, auditPublishMethods.MANUAL), /*#__PURE__*/React.createElement(MenuItem, {
      value: auditPublishMethods.AUTOMATIC,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 637,
        columnNumber: 37
      }
    }, auditPublishMethods.AUTOMATIC))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 645,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 648,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 649,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleVodProviders",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 650,
        columnNumber: 33
      }
    }, "Visible VOD Providers"), /*#__PURE__*/React.createElement(Input, {
      id: "visibleVodProviders",
      value: this.state.visibleVodProviders,
      fullWidth: true,
      onChange: this.handleChange('visibleVodProviders'),
      "aria-describedby": "visibleVodProviders-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 651,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "visibleVodProviders-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 654,
        columnNumber: 33
      }
    }, "Input a comma-separated list of VOD providers"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 659,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 660,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleCompanyIds",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 661,
        columnNumber: 33
      }
    }, "Visible Company IDs"), /*#__PURE__*/React.createElement(Input, {
      id: "visibleCompanyIds",
      value: this.state.visibleCompanyIds,
      fullWidth: true,
      onChange: this.handleChange('visibleCompanyIds'),
      "aria-describedby": "visibleCompanyIds-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 662,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "visibleCompanyIds-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 665,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Company IDs"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 670,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 671,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleImageTypeIds",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 672,
        columnNumber: 33
      }
    }, "Visible ImageType IDs"), /*#__PURE__*/React.createElement(Input, {
      id: "visibleImageTypeIds",
      value: this.state.visibleImageTypeIds,
      fullWidth: true,
      onChange: this.handleChange('visibleImageTypeIds'),
      "aria-describedby": "visibleVodProviders-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 673,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "visibleImageTypeIds-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 676,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Image Type IDs")))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 682,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 685,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 686,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleUploadProviders",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 687,
        columnNumber: 33
      }
    }, "Visible Upload Providers"), /*#__PURE__*/React.createElement(Input, {
      id: "visibleUploadProviders",
      value: this.state.visibleUploadProviders,
      fullWidth: true,
      onChange: this.handleChange('visibleUploadProviders'),
      "aria-describedby": "visibleUploadProviders-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 688,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "visibleUploadProviders-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 692,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Provider names"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 697,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 698,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleLegacyUploadProviders",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 699,
        columnNumber: 33
      }
    }, "Visible Legacy Upload Providers"), /*#__PURE__*/React.createElement(Input, {
      id: "visibleLegacyUploadProviders",
      value: this.state.visibleLegacyUploadProviders,
      fullWidth: true,
      onChange: this.handleChange('visibleLegacyUploadProviders'),
      "aria-describedby": "visibleLegacyUploadProviders-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 701,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "visibleLegacyUploadProviders-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 705,
        columnNumber: 33
      }
    }, "Input a comma-separated list of legacy Provider names"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 710,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 711,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "imageDistributorCompanyId",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 712,
        columnNumber: 33
      }
    }, "Image Distributor Company Id"), /*#__PURE__*/React.createElement(Input, {
      id: "imageDistributorCompanyId",
      value: this.state.imageDistributorCompanyId,
      fullWidth: true,
      onChange: this.handleChange('imageDistributorCompanyId'),
      "aria-describedby": "imageDistributorCompanyId-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 714,
        columnNumber: 33
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 722,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 725,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 726,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "relaxedProgramTypes",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 727,
        columnNumber: 33
      }
    }, "Relaxed Program Types"), /*#__PURE__*/React.createElement(Input, {
      id: "relaxedProgramTypes",
      value: this.state.relaxedProgramTypes,
      fullWidth: true,
      onChange: this.handleChange('relaxedProgramTypes'),
      "aria-describedby": "relaxedProgramTypes-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 728,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "relaxedProgramTypes-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 731,
        columnNumber: 33
      }
    }, "Input a comma-separated list of program types"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 736,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.seriesMasterRollupEnabled,
        onChange: this.handleCheckChange('seriesMasterRollupEnabled'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 739,
          columnNumber: 56
        }
      }),
      label: "Series Master Rollup Enabled",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 737,
        columnNumber: 29
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 748,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 751,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 752,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "seriesMasterRollupVODProviderSource",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 753,
        columnNumber: 33
      }
    }, "Series Master Rollup VOD Provider Source"), /*#__PURE__*/React.createElement(Select, {
      value: this.state.seriesMasterRollupVODProviderSource,
      onChange: this.handleChange('seriesMasterRollupVODProviderSource'),
      "aria-describedby": "seriesMasterRollupVODProviderSource-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 755,
        columnNumber: 33
      }
    }, Object.keys(PROVIDER_SOURCE).sort().map(providerSource => /*#__PURE__*/React.createElement(MenuItem, {
      value: PROVIDER_SOURCE[providerSource],
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 759,
        columnNumber: 41
      }
    }, PROVIDER_SOURCE[providerSource]))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 767,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.seriesMasterRollupExclusivesOnly,
        onChange: this.handleCheckChange('seriesMasterRollupExclusivesOnly'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 770,
          columnNumber: 56
        }
      }),
      label: "Series Master Rollup Exclusives Only",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 768,
        columnNumber: 29
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 779,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 782,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 783,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "shortformPrefixes",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 784,
        columnNumber: 33
      }
    }, "Shortform Prefixes"), /*#__PURE__*/React.createElement(Input, {
      id: "shortformPrefixes",
      value: this.state.shortformPrefixes,
      fullWidth: true,
      onChange: this.handleChange('shortformPrefixes'),
      "aria-describedby": "shortformPrefixes-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 785,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "shortformPrefixes-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 788,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Shortform Prefixes"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 793,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 794,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "longformPrefixes",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 795,
        columnNumber: 33
      }
    }, "Longform Prefixes"), /*#__PURE__*/React.createElement(Input, {
      id: "longformPrefixes",
      value: this.state.longformPrefixes,
      fullWidth: true,
      onChange: this.handleChange('longformPrefixes'),
      "aria-describedby": "longformPrefixes-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 796,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "longformPrefixes-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 799,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Longform Prefixes"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 804,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 805,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "liveEventPrefixes",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 806,
        columnNumber: 33
      }
    }, "Live Event Prefixes"), /*#__PURE__*/React.createElement(Input, {
      id: "liveEventPrefixes",
      value: this.state.liveEventPrefixes,
      fullWidth: true,
      onChange: this.handleChange('liveEventPrefixes'),
      "aria-describedby": "liveEventPrefixes-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 807,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "liveEventPrefixes-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 810,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Live Event Prefixes")))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 816,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 819,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 820,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "defaultAspectRatio",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 821,
        columnNumber: 33
      }
    }, "Default Aspect Ratio"), /*#__PURE__*/React.createElement(Input, {
      id: "defaultAspectRatio",
      value: this.state.defaultAspectRatio,
      fullWidth: true,
      onChange: this.handleChange('defaultAspectRatio'),
      "aria-describedby": "defaultAspectRatio-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 822,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 829,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 830,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "defaultSpecialSelectionRule",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 831,
        columnNumber: 33
      }
    }, "Default Special Selection Rule"), /*#__PURE__*/React.createElement(Input, {
      id: "defaultSpecialSelectionRule",
      value: this.state.defaultSpecialSelectionRule,
      fullWidth: true,
      onChange: this.handleChange('defaultSpecialSelectionRule'),
      "aria-describedby": "defaultSpecialSelectionRule-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 833,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 841,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 842,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "specialSelectionRules",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 843,
        columnNumber: 33
      }
    }, "Special Selection Rules"), /*#__PURE__*/React.createElement(Input, {
      id: "specialSelectionRules",
      value: this.state.specialSelectionRules,
      fullWidth: true,
      onChange: this.handleChange('specialSelectionRules'),
      "aria-describedby": "specialSelectionRules-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 844,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "specialSelectionRules-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 848,
        columnNumber: 33
      }
    }, "Input a comma-separated list of SelectionRule titles")))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-evenly',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 854,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 857,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 858,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "partnerOwnerId",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 859,
        columnNumber: 33
      }
    }, "PartnerOwnerId"), /*#__PURE__*/React.createElement(Input, {
      id: "partnerOwnerId",
      value: this.state.partnerOwnerId,
      fullWidth: true,
      onChange: this.handleChange('partnerOwnerId'),
      "aria-describedby": "partnerOwnerId-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 860,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 867,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      fullWidth: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 868,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "visibleLocationIds",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 869,
        columnNumber: 33
      }
    }, "Visible Location IDs"), /*#__PURE__*/React.createElement(Input, {
      id: "visibleLocationIds",
      value: this.state.visibleLocationIds,
      fullWidth: true,
      onChange: this.handleChange('visibleLocationIds'),
      "aria-describedby": "visibleLocationIds-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 870,
        columnNumber: 33
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, {
      id: "visibleLocationIds-helper-text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 873,
        columnNumber: 33
      }
    }, "Input a comma-separated list of Visible Location IDs"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 878,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.extendedSearchEnabled,
        onChange: this.handleCheckChange('extendedSearchEnabled'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 881,
          columnNumber: 56
        }
      }),
      label: "Extended Search Enabled",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 879,
        columnNumber: 29
      }
    }))), this.state.mode === MODE.UPDATE && /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 889,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 891,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'h6',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 892,
        columnNumber: 29
      }
    }, "Refresh Program Cache:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 894,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 895,
        columnNumber: 29
      }
    }, "Mark one of these as true to refresh program cache during this update. This value is not persisted.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-around',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 899,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 902,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.refreshProgramCache,
        onChange: this.handleCheckChange('refreshProgramCache'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 905,
          columnNumber: 60
        }
      }),
      label: "Refresh Program Cache",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 903,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      md: 6,
      lg: 6,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 914,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.refreshProgramCacheAsynchronously,
        onChange: this.handleCheckChange('refreshProgramCacheAsynchronously'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 917,
          columnNumber: 60
        }
      }),
      label: "Refresh Program Cache Asynchronously",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 915,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 927,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'h6',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 928,
        columnNumber: 29
      }
    }, "Null Fields:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 930,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 931,
        columnNumber: 29
      }
    }, "Any field marked true below will be set to null on this update, ", /*#__PURE__*/React.createElement(Box, {
      component: 'span',
      fontStyle: "italic",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 932,
        columnNumber: 41
      }
    }, "even if the field is populated above"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      alignContent: 'center',
      alignItems: 'center',
      justify: 'space-around',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 936,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 939,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.visibleVodProvidersNullable,
        onChange: this.handleCheckChange('visibleVodProvidersNullable'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 942,
          columnNumber: 60
        }
      }),
      label: "Visible VOD Providers",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 940,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 950,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.relaxedProgramTypesNullable,
        onChange: this.handleCheckChange('relaxedProgramTypesNullable'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 953,
          columnNumber: 60
        }
      }),
      label: "Relaxed Program Types",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 951,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      className: classes.centerText,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 961,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControl,
      style: {
        textAlign: 'center'
      },
      fullWidth: true,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.visibleCompanyIdsNullable,
        onChange: this.handleCheckChange('visibleCompanyIdsNullable'),
        color: "primary",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 964,
          columnNumber: 60
        }
      }),
      label: "Visible Company IDs",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 962,
        columnNumber: 33
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 975,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "primary",
      onClick: () => {
        if (this.state.mode === MODE.CREATE) {
          this.submitUserCreationRequest().then(() => console.log('User creation request submitted.'));
        } else if (this.state.mode === MODE.UPDATE) {
          this.submitUserUpdateRequest();
        }
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 976,
        columnNumber: 25
      }
    }, "Submit"))));
  }
  validateUserManagementRequest(ignoreBlankableFields, isUpdate) {
    const _this$state5 = this.state,
      username = _this$state5.username,
      email = _this$state5.email,
      satClientId = _this$state5.satClientId,
      satClientSecret = _this$state5.satClientSecret,
      role = _this$state5.role,
      provider = _this$state5.provider,
      visiblePartnerIds = _this$state5.visiblePartnerIds,
      visibleEntityProviders = _this$state5.visibleEntityProviders,
      active = _this$state5.active,
      auditMethod = _this$state5.auditMethod,
      publishMethod = _this$state5.publishMethod,
      visibleVodProviders = _this$state5.visibleVodProviders,
      visibleCompanyIds = _this$state5.visibleCompanyIds,
      visibleImageTypeIds = _this$state5.visibleImageTypeIds,
      visibleVodProvidersNullable = _this$state5.visibleVodProvidersNullable,
      relaxedProgramTypes = _this$state5.relaxedProgramTypes,
      relaxedProgramTypesNullable = _this$state5.relaxedProgramTypesNullable,
      visibleCompanyIdsNullable = _this$state5.visibleCompanyIdsNullable,
      partnerOwnerId = _this$state5.partnerOwnerId,
      extendedSearchEnabled = _this$state5.extendedSearchEnabled;
    if (isABlankString(username)) {
      return {
        field: 'Username',
        result: false
      };
    }
    if (isABlankString(email)) {
      return {
        field: 'Email Address',
        result: false
      };
    }
    if (isABlankString(satClientId) && ignoreBlankableFields === false) {
      return {
        field: 'Sat Client ID',
        result: false
      };
    }
    if (isABlankString(satClientSecret) && ignoreBlankableFields === false) {
      return {
        field: 'Sat Client Secret',
        result: false
      };
    }
    if (isABlankString(role)) {
      return {
        field: 'Role',
        result: false
      };
    }
    if (isABlankString(provider)) {
      return {
        field: 'Provider',
        result: false
      };
    }

    // LegacyProvider can be left null

    // MERPLAT-3426: visibleEntityProviders and visiblePartnerIds are no longer nullable and cannot be empty
    if (visiblePartnerIds == null || visiblePartnerIds === undefined || visiblePartnerIds === [] || visiblePartnerIds.length === 0) {
      return {
        field: 'Visible Partner IDs',
        result: false,
        nullableFlag: false
      };
    }
    if (visibleEntityProviders == null || visibleEntityProviders === undefined || visibleEntityProviders === [] || visibleEntityProviders.length === 0) {
      return {
        field: 'Visible Entity Providers',
        result: false,
        nullableFlag: false
      };
    }

    // MERPLAT-3426: visibleVodProviders can be null or empty on create
    if (isUpdate === true && visibleVodProvidersNullable === false) {
      if (visibleVodProviders == null || visibleVodProviders === [] || visibleVodProviders === '') {
        return {
          field: 'Visible VOD Providers',
          result: false,
          nullableFlag: true
        };
      }
    }

    // Can be updated to null as of MERPLAT-3135
    if (isUpdate === true && visibleCompanyIdsNullable === false) {
      if (visibleCompanyIds == null || visibleCompanyIds === [] || visibleCompanyIds === '') {
        return {
          field: 'Company IDs',
          result: false,
          nullableFlag: true
        };
      }
    }
    if (visibleImageTypeIds == null || visibleImageTypeIds === [] || visibleImageTypeIds === '') {
      return {
        field: 'Visible Image Type IDs',
        result: false
      };
    }
    if (active == null || active !== true && active !== false) {
      return {
        field: 'Active',
        result: false
      };
    }
    if (extendedSearchEnabled == null || extendedSearchEnabled !== true && extendedSearchEnabled !== false) {
      return {
        field: 'Extended Search Enabled',
        result: false
      };
    }
    if (auditMethod == null || auditMethod !== auditPublishMethods.MANUAL && auditMethod !== auditPublishMethods.AUTOMATIC) {
      return {
        field: 'Audit Method',
        result: false
      };
    }
    if (publishMethod == null || publishMethod !== auditPublishMethods.MANUAL && publishMethod !== auditPublishMethods.AUTOMATIC) {
      return {
        field: 'Publish Method',
        result: false
      };
    }

    // visibleUploadProviders and visibleLegacyUploadProviders can be empty

    if (isUpdate === true && relaxedProgramTypesNullable === false) {
      if (relaxedProgramTypes == null || relaxedProgramTypes === [] || relaxedProgramTypes === '') {
        return {
          field: 'Relaxed Program Types',
          result: false,
          nullableFlag: true
        };
      }
    }
    if (partnerOwnerId != null && isNaN(partnerOwnerId)) {
      return {
        message: "Partner Owner ID must contain only numbers",
        result: false
      };
    }
    return {
      field: null,
      result: true
    };
  }
}
function arrayFromCommaSeparatedListString(commaSeparatedListString) {
  if (Array.isArray(commaSeparatedListString)) {
    return commaSeparatedListString;
  }
  if (commaSeparatedListString != null && typeof commaSeparatedListString === "string" && commaSeparatedListString !== '') {
    commaSeparatedListString = commaSeparatedListString.trim();
    return commaSeparatedListString.split(',');
  } else {
    return [];
  }
}

/**
 * For some reason I made some enums lowercase. That was stupid
 * TODO: undo that error
 */
function determineValue(valueIn, object) {
  if (valueIn != null && typeof valueIn === "string") {
    const values = Object.values(object);
    let upper = valueIn.toUpperCase();
    let lower = valueIn.toLowerCase();
    if (values.includes(upper)) {
      return upper;
    } else if (values.includes(lower)) {
      return lower;
    }
  }
  return null;
}

/*
 * Again, stupid me made roles lowercase in the enum TODO: Fix
 */
function appendIfNotNull(data, field, fieldName) {
  if (field != null && isNotABlankString(field) && isNotAnEmptyArray(field)) {
    if (fieldName === 'role') field = field.toUpperCase();
    data.append(fieldName, field);
  }
}
export const visiblePartners = {
  COX: {
    ID: '7484463414305825191',
    NAME: "Cox"
  },
  COMCAST: {
    ID: '6462646264594701191',
    NAME: "Comcast"
  },
  SHAW: {
    ID: '8591299509139489191',
    NAME: "Shaw"
  },
  ROGERS: {
    ID: '9141944918962630191',
    NAME: "Rogers"
  },
  VIDEOTRON: {
    ID: '7037701442317809191',
    NAME: "Videotron"
  },
  NBCOTT: {
    ID: "5651333309341214191",
    NAME: "NBC OTT"
  }
};
const auditPublishMethods = {
  AUTOMATIC: "AUTO",
  MANUAL: "MANUAL"
};
const VISIBLE_ENTITY_PROVIDERS = {
  ADI: "ADI",
  MERLIN: "MERLIN",
  NBC: "NBC"
};
export const MODE = {
  CREATE: BASE_URIS.createUser,
  UPDATE: BASE_URIS.updateUser
};
export default withStyles(styles)(withRouter(ManageUser));